export default "__VITE_ASSET__BArlv7db__"